/*eslint-disable */

import Quiz from '@/components/contestQuizzort/index';
import appFooter from '@/components/public/common/footer/';
import {bus} from '@/main';

var $ = window.jQuery = jQuery = require('jquery');
export default {
  name: 'contest-quiz',
  components: {
    'app-footer': appFooter,
    'quiz-format': Quiz
  },
  data() {
    return {
      quizDetails: '',
      totalTime: 0,
      quizZ: {
        sections: []
      },
      contestDetailsById:{},
      contestConfirmClosed:false,
      contestAlertTrue:false,
      contestAlertHideCompletedState:false
    }
  },
  computed: {

  },
  mounted() {
    bus.$on('contestAlertShown', (data) => {
      this.contestAlertTrue = data;
    })
    bus.$on('contestAlertHideCompleted', (data) => {
      this.contestAlertHideCompletedState = data;
    })
    $('.quizloader,.courseloader').hide();
    $('body').addClass('user_quiz_popup_active');
    this.contestDetailsById = JSON.parse(localStorage.getItem('contestDetails'))
    $('.quizloader,.courseloader').show();
    if(this.contestDetailsById  != undefined){
      this.totalTime = this.contestDetailsById.time_limit
      this.quizZ.sections = this.contestDetailsById.sections;
      this.quizDetails = this.contestDetailsById ;
      $('.quizloader,.courseloader').hide();
    }
  },
  methods: {
    contestConfirmOpenedfun(){
      this.contestConfirmClosed = true
      $('body').addClass("contentQuizBody")
    },
    contestConfirmClosedfun(){
      this.contestConfirmClosed = false
      $('body').removeClass("contentQuizBody")
    },
    // getCourseQuizDetails: function() {
    //   $('.quizloader,.courseloader').show();
    //   let quizListUrlLink = root.contestQuizDetailLink.link + this.$route.params.quizId + '/';
    //   axios.get(quizListUrlLink).then(response => {
    //     if (response.status === 200) {
    //       this.totalTime = response.data.data.time_limit;
    //       this.quizZ.sections = response.data.data.sections;
    //       this.quizDetails = response.data.data;
    //       console.log(this.quizZ.sections, "Quiz Details")
    //       $('.quizloader,.courseloader').hide();
    //     }
    //   }).catch(err => {
    //     toast.error(err.data.data.message);
    //     this.$router.go(-1);
    //     $('.quizloader,.courseloader').hide();
    //   })
    // },
  userQuizClose(){
    this.$router.go(-1);
    $('body').removeClass("contentQuizBody")
    localStorage.removeItem('contestDetails')
    $('.quizloader,.courseloader').hide();
    setTimeout(() => {
      $('body').removeClass('user_quiz_popup_active');
    }, 50);
  },
  },
  created() {
    bus.$on('contestAlertShown', (data) => {
      this.contestAlertTrue = data;
    })
  },
  beforeCreate: function() {

  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('user_quiz_popup_active');
    $('body').removeClass("contentQuizBody")
    next();
  },
}